<template>
  <div class="table-container">
    <table aria-label="welcome biography">
      <!-- <tr>
        <td rowspan="60" width="20%">
          <img v-if="patient.gender === 'M'" src="@/assets/images/avatar-male.jpg" class="welcome__avatar"/>
          <img v-else src="@/assets/images/avatar-female.jpg" class="welcome__avatar"/>
        </td>
      </tr> -->

      <tr v-if="patient.phone1">
        <td class="welcome__info">
          <font-awesome-icon icon="phone" class="icon"/><b>{{patient.phone1Type ? allData.phoneTypes.find(type => type.id == favorite.phone1Type).type + ': ' : 'Primary: '}}</b><a class="phone1" :href="'tel:'+patient.phone1">{{patient.phone1}}</a>
        </td>
      </tr>

      <tr v-if="patient.phone2">
        <td class="welcome__info">
          <font-awesome-icon icon="phone" class="icon"/><b>{{patient.phone2Type ? allData.phoneTypes.find(type => type.id == favorite.phone2Type).type + ': ' : 'Secondary: '}}</b><a class="phone1" :href="'tel:'+patient.phone2">{{patient.phone2}}</a>
        </td>
      </tr>

      <tr v-if="patient.email">
        <td class="welcome__info">
          <font-awesome-icon icon="inbox" class="icon"/><b> E-mail: </b><a class="email" :href="'mailto:'+patient.email">{{patient.email}}</a>
        </td>
      </tr>

      <tr v-if="getFullAddress()!=''">
        <td class="welcome__info">
          <font-awesome-icon icon="map-marker-alt" class="icon"/><b> Address: </b>{{getFullAddress()}}
        </td>
      </tr>

      <!-- <tr v-if="patient.fax">
        <td class="welcome__info">
          <font-awesome-icon icon="fax" class="icon"/>
          <b>Fax:</b> {{ patient.fax }}
        </td>
      </tr> -->
    </table>
  </div>
</template>

<script>

  export default {
    name: "WelcomeBio",
    data() {
      return {
        allData: this.$store.getters['login/getAllData'],
      }
    },
    props: {
      patient: Object,
    },
    methods: {
      getFullAddress(){ 
        let answer = ''
        let values = [this.patient.address, this.patient.addr2, this.patient.city]
        values.forEach(function (item){
          if (item){
            if (answer==='')
              answer+=item
            else
              answer= answer + ', ' + item
          }
        })
        if (this.patient.state) {
          let stateName = this.allData.states.find(state => state.id == this.patient.state).name
          if (answer == '')
            answer += stateName
          else
            answer = answer + ', ' + stateName
        }
        if (this.patient.zip) {
          if (answer == '')
            answer += this.patient.zip
          else
            answer = answer + ', ' + this.patient.zip
        }
        return answer
      }
    }
  }
</script>

<style scoped lang="scss">
  $color-font: darken(#58595b, 10%);
  table {
    text-align: left;
    width: 100%;
  }

  tr {
    font-size: 0.95em;
  }

  .table-container {
    padding: 1em 2em 1.5em;
  }

  .welcome__avatar {
    width: 100px;
  }

  .welcome__title {
    font-size: 1.5em;
  }

  .welcome__info {
    color: $color-font;
    line-height: 1.8em;
  }

  .icon {
    margin-right: 0.5em;
  }

  .capitalize {
    text-transform: capitalize;
  }
</style>